export function isValidFileExtension(file: File, extensions: string[]) {
  const splittedValue = file.name.split('.');
  const extension = splittedValue.at(-1);
  return extension ? extensions.includes(extension) : false;
}
